import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { prerenderedLoadable } from 'utils/prefetch';
const AboutUsPage = prerenderedLoadable(() => import(/* webpackChunkName: "AboutUs" */ './AboutUs'));
export const AboutUs = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
    React.createElement(AboutUsPage, null)));
